import { notify } from 'notiwind'
import type { CvExtraction } from '~/types/apply'

/** Calls POST /ml/cv-extract; a failure falls back to a manual fill (null) with a toast. */
export function useCvExtraction() {
  const client = useStrapiClient()

  const extractCv = async (cv: File, coverLetterText?: string | null): Promise<CvExtraction | null> => {
    try {
      const formData = new FormData()
      formData.append('cv', cv)
      if (coverLetterText) formData.append('coverLetterText', coverLetterText)
      return await client<CvExtraction>('/ml/cv-extract', { method: 'POST', body: formData })
    } catch (error) {
      console.error('[CvExtraction] CV extraction failed:', error)
      notify({
        group: 'main',
        type: 'danger',
        title: 'L’analyse du CV a échoué',
        text: 'Les informations n’ont pas pu être extraites. Vous pouvez continuer et remplir le profil manuellement.'
      })
      return null
    }
  }

  return { extractCv }
}
